<!-- <router-outlet /> -->
@if(isAuthenticated){
<ng-container>
    <!-- <p>Authenticated</p> -->
    <div class="app-container">
        <router-outlet></router-outlet>
    </div>
</ng-container>
}
@else{
    <ng-container >
        <!-- <p>Not Authenticated</p> -->
        <div class="app-container"> 
            <router-outlet></router-outlet>
        </div>
    </ng-container>
}